import { BaseMapList } from './BaseMapList';
import { useLocalization } from '@ais-ui/locale-management';

export function BaseMapForm() {
  const { messages } = useLocalization();

  return (
    <div className="space-y-6 w-full">
      <BaseMapList />
    </div>
  );
}
